export const fr = {
    single: 'Unifocaux',
    multifocal: 'Progressifs',
    overview: 'Aperçu',
    glassesPackage: 'Pack de verres',
    frame: 'Montures de lunettes de soleil',
    glassesPrice: 'Prix des lunettes',
    youPay: 'Prix total',
    free: 'Gratuit',
    errorFetching: 'Une erreur est survenue',
    tooltipText: 'Non disponible',
    extraOption: `Vous souhaitez ajouter une option supplémentaire ?`,
    readingArea: {
        normal: 'Zone de lecture normale',
        wide: 'Zone de lecture très larges',
        extraWide: 'Zone de lecture extra larges',
        veryWide: 'Zone de lecture extra larges',
    },
    footer: `Veuillez noter que vous pouvez commander des verres en ligne avec différents emballages et options de verre, mais que toutes les options de verre supplémentaires ne sont pas possibles lors de la commande en ligne. Vous avez des questions ? <1>N'hésitez pas à nous contacter</1>.`,
};
